import { c as _c } from "react/compiler-runtime";
import React, { ReactElement, useEffect, useReducer } from 'react';
import ImageComponent from '@spa/components/image-component/image.component';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import styles from './store-stock-info.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
import { useStoresAPI } from '@spa/lib/react/hooks/useStoresAPI';
export interface StoreStockInfoComponentProps {
  readonly productCode: string;
  readonly storeCode: string;
}
interface State {
  readonly isAvailable: boolean;
  readonly loadingError: boolean;
}
type Action = {
  readonly type: 'stockLoaded';
  readonly isAvailable: boolean;
} | {
  readonly type: 'stockFailed';
};
const initialState: State = {
  isAvailable: false,
  loadingError: false
};
function reducer(_state: State, action: Action): State {
  switch (action.type) {
    case 'stockLoaded':
      return {
        isAvailable: action.isAvailable,
        loadingError: false
      };
    case 'stockFailed':
      return {
        isAvailable: false,
        loadingError: true
      };
  }
}
function StoreStockInfoComponent(t0) {
  const $ = _c(9);
  const {
    productCode,
    storeCode
  } = t0;
  const {
    formatMessage
  } = useNamespacedIntl("storefinder");
  const {
    getStoreStockIndicatorForProduct
  } = useStoresAPI();
  const [t1, dispatch] = useReducer(reducer, initialState);
  const {
    isAvailable,
    loadingError
  } = t1;
  let t2;
  let t3;
  if ($[0] !== getStoreStockIndicatorForProduct || $[1] !== productCode || $[2] !== storeCode) {
    t2 = () => {
      let cancelled = false;
      if (productCode) {
        const fetchStock = async () => {
          try {
            const stockData = await getStoreStockIndicatorForProduct(productCode, storeCode);
            if (!cancelled) {
              dispatch({
                type: "stockLoaded",
                isAvailable: stockData
              });
            }
          } catch {
            if (!cancelled) {
              dispatch({
                type: "stockFailed"
              });
            }
          }
        };
        fetchStock();
      }
      return () => {
        cancelled = true;
      };
    };
    t3 = [getStoreStockIndicatorForProduct, productCode, storeCode];
    $[0] = getStoreStockIndicatorForProduct;
    $[1] = productCode;
    $[2] = storeCode;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== formatMessage || $[6] !== isAvailable || $[7] !== loadingError) {
    t4 = loadingError ? <span>{formatMessage("loadingError")}</span> : <span><ImageComponent src={isAvailable ? "/assets/icons/ellipse.svg" : "/assets/icons/ellipse-red.svg"} alt="availability icon" width={12} height={12} /><span className={isAvailable ? `${styles["store-stock-info__product-available"]} bold` : `${styles["store-stock-info__product-unavailable"]} bold`}>{formatMessage(isAvailable ? "available" : "unavailable")}</span></span>;
    $[5] = formatMessage;
    $[6] = isAvailable;
    $[7] = loadingError;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
export default StoreStockInfoComponent;